import React from 'react';

const NotAuthorized = () => {
    return (
        <div style={styles.container}>
            <label style={styles.header}>Not Authorized</label>
            <p style={styles.message}>You do not have permission to view this page.</p>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f8f8f8',
        color: '#333',
        fontFamily: 'Arial, sans-serif',
    },
    header: {
        fontSize: '25px',
        margin: '0.5em',
    },
    message: {
        fontSize: '12px',
        margin: '0.5em',
    },
};

export default NotAuthorized;
